import React from 'react';
import { useTheme } from '@emotion/react';
import { useSelector } from 'react-redux';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { qaAttribute } from '@gumtree/ui-library/src/utils/qa-service';
import { DeviceTypes } from '@gumtree/shared/src/types/client-data';
import { useShowPayShipFeature } from '@gumtree/shared/src/hooks/useShowPayShipFeature';
import { GrowthBookFeature } from '@gumtree/shared/src/model/experiment';
import SideMenuSection from './side-menu-section';
import sideMenuData from './side-menu-data';
import SideNav from '../side-nav/side-nav';
import { sideMenuCss } from './side-menu.style';
import type { OpenDialog } from '../../use-modal';
import type { ShellState } from '../../reducers/common';

interface SideMenuProps {
    baseConfig: {
        sellerUrl: string;
        device: {
            type?: DeviceTypes;
            os?: string;
        };
        pageType: string;
    };
    isLoggedIn?: boolean;
    openDialog?: OpenDialog;
    isMhhExperiment?: boolean;
    useMhhLayout?: boolean;
}

const SideMenu: React.FC<SideMenuProps> = ({
    baseConfig: { device, pageType, sellerUrl },
    isLoggedIn = false,
    openDialog = () => null,
    isMhhExperiment = false,
    useMhhLayout = false,
}) => {
    const theme = useTheme();
    const showPayShipFeature = useShowPayShipFeature();
    const showUnreadCount = useFeatureIsOn(GrowthBookFeature.UNREAD_FEATURE_FLAG);
    const unreadMessagesCount = useSelector(
        ({ unreadMessagesCount }: ShellState) => unreadMessagesCount
    );

    return (
        <div className="side-menu-container" css={sideMenuCss(theme)}>
            <SideNav dark right isMhhExperiment={isMhhExperiment} isLoggedIn={isLoggedIn} useMhhLayout={useMhhLayout}>
                {({ close }: { close: () => void }) => (
                    <nav className="side-menu" {...qaAttribute('side-menu')}>
                        {sideMenuData({ device, sellerUrl }, isLoggedIn, showPayShipFeature, isMhhExperiment).map(
                            (section) => (
                                <SideMenuSection
                                    key={section.id}
                                    isLoggedIn={isLoggedIn}
                                    title={section.title}
                                    openDialog={openDialog}
                                    onItemClick={close}
                                    items={section.items}
                                    pageType={pageType}
                                    unreadMessagesCount={showUnreadCount ? unreadMessagesCount : 0}
                                />
                            )
                        )}
                    </nav>
                )}
            </SideNav>
        </div>
    );
};

export default SideMenu;
